import { render, staticRenderFns } from "./Collision.vue?vue&type=template&id=626c089c&scoped=true&"
import script from "./Collision.vue?vue&type=script&lang=js&"
export * from "./Collision.vue?vue&type=script&lang=js&"
import style0 from "./Collision.vue?vue&type=style&index=0&id=626c089c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626c089c",
  null
  
)

export default component.exports